import React from 'react'

function AdminProfile() {
  return (
    <div className='common-ui-section-design'>Admin Profile</div>
  )
}

export default AdminProfile